export default "__VITE_ASSET__5fe46539__"